const styleSheet = new CSSStyleSheet({ media: 'screen' })
const css = (str) => str[0]

styleSheet.replace(css`
  html :where(.wp-block) {
    max-width: 100%;
  }

  html :where(.wp-block)[data-align=wide] {
    max-width: var(--layout-block-width-wide);
  }

  html :where(.wp-block) {
    margin-top: var(--layout-block-spacing);
  }

  html :where(.editor-styles-wrapper) h1,
  html :where(.editor-styles-wrapper) h2,
  html :where(.editor-styles-wrapper) h3,
  html :where(.editor-styles-wrapper) h4,
  html :where(.editor-styles-wrapper) h5,
  html :where(.editor-styles-wrapper) h6,
  html :where(.editor-styles-wrapper) p {
    margin: 0;
  }
`)

export default styleSheet
